import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = () => ({
})

export const getters = {
}

export const actions = {
 populateFromDB: async ({ commit, dispatch }, payload) => {
        dispatch('populateSettingsFromDB')
        if (payload) {
            commit('SET_USER_MODULE_CONTENT', payload)
        }
    },
    populateSettingsFromDB: async ({ commit }) => {
        axios.post('/api/pcs/terminal', {
            params: {
                pcs: localStorage.getItem('pcs')
            }
        }).then(res => {
            commit("SET_MODULE_DATA", res.data['settings'])
        })
    },
    updateStateInDB: async ({state, rootState}) => {
        await axios.post('/api/updateModule', {
            params: {
                moduleState: state,
                moduleName: MODULES.TERMINAL,
                pcs: localStorage.getItem('pcs'),
                classId: rootState.auth.classId,
            } 
        })
    },
}

export const mutations = {
   SET_MODULE_DATA(state, payload) {
        // populate from settings in database
        // example 
        // if (payload.textContent) state.waiver = payload.textContent 
    },
    SET_USER_MODULE_CONTENT(state, payload){
        // Set module content from user_has_module content
    },
}